import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { DefaultButton } from '@bingads-webui-react/fabric-control';
import { withRawStyles } from '@bingads-webui-react/with-raw-styles';
import { getToggleButtonFilterStyle } from './style';

const ToggleButtonFilterInternal = ({
  onChecked,
  checked,
  text,
  iconName,
  styles,
}) => {
  //
  const onClick = useCallback(() => {
    if (onChecked) {
      onChecked(!checked);
    }
  }, [checked, onChecked]);

  const iconProps = useMemo(() => ({ iconName }), [iconName]);

  return (
    <DefaultButton
      toggle
      checked={checked}
      text={text}
      iconProps={iconProps}
      onClick={onClick}
      allowDisabledFocus
      disabled={false}
      styles={styles.button}
    />
  );
};

ToggleButtonFilterInternal.propTypes = {
  onChecked: PropTypes.func,
  checked: PropTypes.bool,
  text: PropTypes.string.isRequired,
  iconName: PropTypes.string.isRequired,
  styles: PropTypes.shape({}).isRequired,
};

ToggleButtonFilterInternal.defaultProps = {
  onChecked: undefined,
  checked: false,
};

export const ToggleButtonFilter
  = withRawStyles(ToggleButtonFilterInternal, getToggleButtonFilterStyle);
